import RequiredDocumentsServices from "../services/RequiredDocumentsServices";
import React from 'react';

class RequiredDocuments {

    getDocumentTypes = async (setLoading: any, productId: any, isPhysicalPerson?: boolean) => {
        const documentTypes: { value: string; label: string; showFor: string, obligatorio: string, documentTypeMetadata: string, grouped: string }[] = [];
        const personaTypesRes = await RequiredDocumentsServices.getDocumentsPersonaTypes({ setLoading, loader: true });
        const DOC_OBLIGA_USER: { value: string, name: string }[] = [];
        const docPersonaTypes = personaTypesRes.ok ? personaTypesRes.data : null;

        if (docPersonaTypes) {
            for (const key in docPersonaTypes) {
                DOC_OBLIGA_USER.push({
                    value: docPersonaTypes[key].value,
                    name: `${
                        key === "TOMADOR" 
                        ? "Tomador* (opción TOMADOR/PÓLIZA del desplegable)" 
                        : key === "EMPRESA"
                            ? "Empresa (opción TOMADOR/PÓLIZA del desplegable"
                            : `Todos los ${docPersonaTypes[key].label}`}`,
                });
            }
        }
                    
        const permissions = await RequiredDocumentsServices.getRequiredDocuments({ setLoading, loader: true, product: productId })
        // Añadimos caso especial cuando se pide diferente documento
        // si el tomador es persona física o persona jurídica
        let filteredPermissions: any[] = permissions;
        const empresaDocs = permissions.filter((item: any) => item.required_documents_usuarios === "E");
        const hasEmpresaDocs = empresaDocs.length > 0;
        if (hasEmpresaDocs && isPhysicalPerson) {
            filteredPermissions = permissions.filter((item: any) => item.required_documents_usuarios !== "E");
        } else if (hasEmpresaDocs && !isPhysicalPerson) {
            filteredPermissions = empresaDocs
        }

        const requiredDocs: JSX.Element[] = [];
        const groupedDocs: string[] = [];

        if (filteredPermissions) {
            filteredPermissions.forEach((x: any) => {
                // En el mismo bucle aprovechamos y damos formato
                documentTypes.push({
                    value: x.documents_tipo,
                    label: x.documents_tipo + " - " + x.documents_descripcion,
                    showFor: x.required_documents_usuarios,
                    obligatorio: x.required_documents_obligatorio,
                    documentTypeMetadata: x.documents_documentType,
                    grouped: x.required_documents_grouped,
                });

                if (x.required_documents_obligatorio) {
                    // Convertimos en array para manejar la ampliación de tipos de usuarios
                    const requiredDocumentsArray = x.required_documents_obligatorio.split("-");
                    let document = (
                        <p>
                            {x.documents_descripcion} para{" "}
                            {DOC_OBLIGA_USER.map((u: any, index) => {
                        if (requiredDocumentsArray.includes(u.value)) {
                            console.log(u)
                            return (
                                <React.Fragment key={u.value}>
                                    <strong>{u.name}</strong>
                                    {requiredDocumentsArray.length > 1 && index !== requiredDocumentsArray.length - 1
                                        ? index === requiredDocumentsArray.length - 2
                                            ? " y "
                                            : ", "
                                        : "."}
                                </React.Fragment>
                            );
                        }
                        // Excepción a la regla: se pide sólo 1 documento por grupo de asegurados
                        if (requiredDocumentsArray.includes(`${u.value}1`)) {
                            for (let key in docPersonaTypes) {
                                if (docPersonaTypes[key].value === u.value) {
                                    return (
                                        <strong key={key}>
                                            uno de los {docPersonaTypes[key].label}
                                        </strong>
                                    );
                                }
                            }
                        }
                                return null;
                            })}
                        </p>
                    );
                    requiredDocs.push(document);
                } else if (!!x.required_documents_grouped) {
                    const document = x.documents_descripcion;
                    groupedDocs.push(document);
                }
            });
        }
        return {
            documentTypes,
            docPersonaTypes,
            requiredDocs,
            groupedDocs,
        }

    };


}

export default new RequiredDocuments();
